export default __webpack_public_path__ + "static/media/magnifying-glass.d6a8245f.svg";